import face1 from "./assets/face-1.avif?url"
import face2 from "./assets/face-2.avif?url"
import face3 from "./assets/face-3.avif?url"
import face4 from "./assets/face-4.avif?url"
import face5 from "./assets/face-5.avif?url"
import guestbookSceneMap from "./assets/guestbook-scene.avif?url"

export default [
  {
    name: "face-1",
    type: "texture",
    path: face1,
  },
  {
    name: "face-2",
    type: "texture",
    path: face2,
  },
  {
    name: "face-3",
    type: "texture",
    path: face3,
  },
  {
    name: "face-4",
    type: "texture",
    path: face4,
  },
  {
    name: "face-5",
    type: "texture",
    path: face5,
  },
  {
    name: "guestbook-scene-map",
    type: "texture",
    path: guestbookSceneMap,
  },
]
